<template>
  <div class="duration-selector">
    <el-form :inline="true" style="text-align:left;" size="small">
      <el-form-item label="">
        <el-button plain round v-on:click="selectSiblingPeriod(0)"
         size="mini" style="margin-right:10px;">上一周期</el-button>
        <el-date-picker
          v-model="selectPeriod"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @change="selectPeriodChangeListener"
        >
        </el-date-picker>
        <el-button plain round v-on:click="selectSiblingPeriod(1)"
        style="margin-left:10px" size="mini">下一周期</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSubmit">查询</el-button>
        <el-button type="primary" size="mini" @click="derive">导出</el-button>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="left" style="margin-top:1rem;">
      <el-button
        v-for="(type, index) of periodTypeList"
        v-on:click="selectPeriodType = type.type"
        :class="getContrastPeriod(type.type)"
        :key="index"
        plain
        size="mini"
        >{{ type.name }}</el-button>
    </el-row>
  </div>
</template>
<script>
import { formatDate } from '@/utils/utils';

export default {
  name: 'duration-selector',
  data() {
    return {
      selectPeriodType: -1,
      selectPeriod: [formatDate(new Date(), 'yyyy-MM-dd 00:00'), formatDate(new Date(), 'yyyy-MM-dd 23:59')],
      periodTypeList: [
        { name: '今日', type: 0 },
        { name: '昨日', type: 1 },
        { name: '本周', type: 2 },
        { name: '本月', type: 3 },
        { name: '最近10日', type: 4 },
        { name: '最近半月', type: 5 },
        { name: '最近30日', type: 6 },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  watch: {
    selectPeriodType(newVal) {
      if (newVal < 0) {
        return;
      }
      this.selectPeriod = this.getSelectPeriod(newVal);
    },
    selectPeriod(newVal) {
      this.$emit('select-duration', newVal);
    },
  },
  created() {
    this.$emit('select-duration', this.selectPeriod);
  },
  methods: {
    getContrastPeriod(type) {
      if (this.skinType) {
        if (type === this.selectPeriodType) {
          return 'el-button--primary is-plain';
        }
        return 'el-button--primary';
      }
      if (type === this.selectPeriodType) {
        return 'el-button--primary';
      }
      return '';
    },
    onSubmit() {
      this.$emit('select-duration', this.selectPeriod);
    },
    derive() {
      this.$emit('select-derive', this.selectPeriod);
    },
    // type 0 上一周期 1 下一周期
    selectSiblingPeriod(type) {
      this.selectPeriodType = -1;
      const duration = this.getPeroidTimeSpan();
      const [start, end] = this.selectPeriod;
      let startDate = new Date(start);
      let endDate = new Date(end);
      const nowTime = Date.now();
      if (type === 0) {
        startDate = formatDate(new Date(startDate.getTime() - duration), 'yyyy-MM-dd 00:00:00');
        endDate = formatDate(new Date(endDate.getTime() - duration), 'yyyy-MM-dd 23:59:59');
      } else {
        startDate = formatDate(new Date(startDate.getTime() + duration), 'yyyy-MM-dd 00:00:00');
        if (new Date(startDate).getTime() > nowTime) {
          this.$message.error('时间不得超过今天!');
          return;
        }
        endDate = formatDate(new Date(endDate.getTime() + duration), 'yyyy-MM-dd 23:59:59');
        if (new Date(endDate).getTime() > nowTime) {
          endDate = formatDate(new Date(nowTime), 'yyyy-MM-dd 23:59:59');
        }
      }
      this.selectPeriod = [startDate, endDate];
    },
    getPeroidTimeSpan() {
      console.log(this.selectPeriod);
      const [startDate, endDate] = this.selectPeriod;
      const duration = new Date(endDate).getTime() - new Date(startDate).getTime();
      return Math.ceil(duration / 1.0 / (24 * 60 * 60 * 1000)) * 24 * 60 * 60 * 1000 + 1;
    },
    selectPeriodChangeListener() {
      this.selectPeriodType = -1;
    },
    getSelectPeriod(newVal) {
      let startDate = new Date(formatDate(new Date(), 'yyyy-MM-dd 00:00:00'));
      let endDate = new Date();
      switch (newVal) {
        // 昨日
        case 1:
          startDate = formatDate(new Date(startDate.getTime() - 24 * 60 * 60 * 1000), 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(new Date(endDate.getTime() - 24 * 60 * 60 * 1000),
            'yyyy-MM-dd 23:59:59');
          break;
          // 本周
        case 2:
          startDate = formatDate(new Date(endDate.getTime() - endDate.getDay() * 24 * 60 * 60 * 1000), 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
          // 本月
        case 3:
          startDate = formatDate(startDate, 'yyyy-MM-01 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
          // 最近十日
        case 4:
          startDate = formatDate(new Date(endDate.getTime() - 10 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
          // 最近半月
        case 5:
          startDate = formatDate(new Date(endDate.getTime() - 15 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
          // 最近30天
        case 6:
          startDate = formatDate(new Date(endDate.getTime() - 30 * 24 * 60 * 60 * 1000), 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
        default:
          startDate = formatDate(startDate, 'yyyy-MM-dd 00:00:00');
          endDate = formatDate(endDate, 'yyyy-MM-dd 23:59:59');
          break;
      }
      return [startDate, endDate];
    },
  },
};
</script>
<style scoped>
.duration-selector{
  padding: 1rem ;
}
</style>
